var filters = {
	$this: $( '.js-filter' ),
	$sub: $( '.js-sub-filter' ),
	$mobileFilter: $( '.js-mobile-filter' ),
	$listingItem: $( '.listing .item' ),
	$current_active: {},
	//setScrollTop: 0,
	openMobileFilter: function() {
		// Open:
		$( '.js-filter .open-select-mobile' ).on( 'click', function( e ) {
			e.preventDefault();
			if ( ! filters.$mobileFilter.hasClass( 'open' ) ) {
				//filters.setScrollTop = $(window).scrollTop();
				$( 'body' ).addClass( 'fixed' );
				//$( '#container' ).css( { 'position': 'fixed', 'margin-top': -Math.abs( filters.setScrollTop ) } );
				filters.$mobileFilter.addClass('open');
				setTimeout( function() {
					$( '.js-mobile-filter .close-filter' ).fadeIn();
					$( '.js-mobile-filter' ).icons.init( '.svg-icon' );
				}, 500 );
			}
		});
		// Close:
		$( '.js-filter .btn-filter-outer, .js-filter .scroller .close-filter' ).on( 'click', function( e ) {
			e.preventDefault();
			if ( filters.$mobileFilter.hasClass( 'open' ) ) {
				filters.$mobileFilter.removeAttr('style').removeClass('open');
				$( 'body' ).removeClass( 'fixed' );
				//$( '#container' ).removeAttr( 'style' );
				$( window ).scrollTop( wizard.setScrollTop );
				$( '.js-mobile-filter .close-filter' ).hide();
			}
		});

	},
	chooseOption: function( option ) {
		// go to overzichtspagina...
		if ( 'undefined' != typeof option ) {
			window.location.href = customData.courseArchive + '?filter=' + option;
		}
	},
	closeSubFilter: function() {
		if ( filters.$this.find( '.main-filters' ).find( '.filter-item.active' ).length < 1 ) {
			filters.$sub.removeClass('open').removeAttr( 'style' );
		}
	},
	openSubFilter: function() {
		if ( !filters.$sub.hasClass( 'open' ) ) {
			var h = filters.$sub.children('.center').height();
			filters.$sub.addClass('open').css( { 'height': h } );

			$( '.archive .clear-selection' ).addClass('active');
		}
	},
	resetFilter: function() {
		filters.$current_active = {};
		filters.$this.find('.filter-item.active').removeClass('active');
		filters.closeSubFilter();
		filters.updateCourses();

		$( '.archive .clear-selection' ).removeClass('active');
	},
	activateFilter: function() {
		$( '.js-filter .filter-item' ).on( 'click', function() {
			var $filterItem = $( '.js-filter .filter-item' );
			if ( Modernizr.mq( '(max-width: 1023px)' ) ) {
				$filterItem = $( '.js-filter .filter-item input[type="checkbox"]' );
			}

			var $item = $( this );
			if ( Modernizr.mq( '(max-width: 1023px)' ) ) {
				$item = $( this ).parents('.filter-item');
			}
			var $field = $item.data('field');
			var $value = $item.data('value');

			if ( $item.hasClass( 'active') ) {
				$item.removeClass( 'active' );

				// unset filter
				if ( 'undefined' != typeof filters.$current_active[ $field ] ) {
					var $index = filters.$current_active[ $field ].indexOf( $value );
					filters.$current_active[ $field ].splice( $index, 1 );
					if ( Object.keys( filters.$current_active ).length >= 1 && 0 == Object.keys( filters.$current_active[ $field ] ).length ) {
						delete filters.$current_active[ $field ];
					}
					// unset all if is main filter
					if ( $item.closest('.main-filters').length > 0 && 'undefined' == typeof filters.$current_active[ 'discipline' ] ) {
						filters.resetFilter();
					} else {
						filters.updateCourses();
					}
				}

			} else {
				$item.addClass( 'active' );

				// set filter
				var $index = 0;
				if ( 'undefined' != typeof filters.$current_active[ $field ] ) {
					$index = filters.$current_active[ $field ].length;
					filters.$current_active[ $field ][ $index ] = $value;
				} else {
					filters.$current_active[ $field ] = [ $value ];
				}

				// if in 'lestype'
				// if ( $item.parents( 'div' ).hasClass( 'filter-lesson' ) ) {
				// 	$item.siblings( '.filter-item' ).removeClass( 'active' );
				// }
				filters.openSubFilter();
				filters.updateCourses();
			}
		} );
	},
	init: function() {
		filters.activateFilter();
		$( '.js-filter .filter-left .select .drop-down ul li' ).on( 'click', function( e ) {
			e.preventDefault();
			if ( 'undefined' != typeof $(this).attr('data-value') ) {
				filters.chooseOption( $(this).data('value') );
			}
		} );
		$( '.archive .clear-selection' ).on( 'click', function( e ) {
			e.preventDefault();
			filters.resetFilter();
		} );
		// $( 'body' ).on( 'click', function (e) {
		// 	console.log(e.target);
		// });
		$( '.js-filter .filter-left select' ).on( 'change', function( ) {
			if ( 'undefined' != typeof $(this).val() ) {
				filters.chooseOption( $(this).val() );
			}
		} );

		filters.updateCounter();

		if ( $( '.main-filters' ).find( '.filter-item.active' ).length > 0 ) {
			var $current_filter = $( '.main-filters' ).find( '.filter-item.active' );
			filters.$current_active[ $current_filter.data('field') ] = [ $current_filter.data('value') ];

			if ( $( '.sub-filter' ).find( '.filter-item.active' ).length > 0 ) {
				$( '.sub-filter .filter-item.active' ).each(function(){
					filters.$current_active[ $(this).data('field') ] = [ $(this).data('value') ];
				});
			}
			filters.openSubFilter();
		}
	},
	updateCourses: function() {

		if ( Object.keys( filters.$current_active ).length > 0 ) {
			filters.$listingItem.addClass('hide');

			var $matches = Object.keys( filters.$current_active ).length;
			$('#archive .listing .item').each(function(){
				var $item = $(this);
				var $item_matches = [];

				for ( var field in filters.$current_active ) {
					for ( var key in filters.$current_active[ field ] ) {
						var value = filters.$current_active[ field ][ key ];
						//if ( $item.is('[data-' + field + '*="' + value + '"]') || 'undefined' == typeof $item.attr('data-' + field ) ) {
						if ( $item.is('[data-' + field + '*="' + value + '"]') ) {
							$item_matches[ field ] = 1;
						}
					}
				}

				if ( $matches == Object.keys( $item_matches ).length ) {
					$item.removeClass('hide');
				}

			});

		} else {
			filters.$listingItem.removeClass('hide');
		}
		$( '.listing .item' ).icons.init( '.svg-icon' );

		filters.updateCounter();
		// if filter isset remove it from url
		window.history.pushState({},"",window.location.pathname );

	},
	updateCounter: function() {
		var $count = $('.listing').find('.item:not(.hide)').length;
		$('#archive .results em').text( $count );
		if ( 1 == $count ) {
			$('#archive .results .text.multi').addClass('hide');
			$('#archive .results .text.single').removeClass('hide');
		} else {
			$('#archive .results .text.multi').removeClass('hide');
			$('#archive .results .text.single').addClass('hide');
		}
	}
};
